import React from "react";
import SimulationProfileSettingsDesktop from "./SimulationProfileSettingsDesktop";
import SimulationProfileSettingsMobile from "./SimulationProfileSettingsMobile";
import "./css/SimulationProfileSettings.css";

function SimulationProfileSettings(props) {
  return (
    <div className="simulation-profile-container">
      <div className="desktop-only">
        <SimulationProfileSettingsDesktop {...props} />
      </div>

      <div className="mobile-only">
        <SimulationProfileSettingsMobile {...props} />
      </div>
    </div>
  );
}

export default SimulationProfileSettings;
